export default function PHP_stripslashes() {
  return (
    <div>
      <h1>PHP_stripslashes</h1>
    </div>
  );
}
